<div class="title">Tiling</div>

<mat-checkbox [(ngModel)]="tilingChecked" (ngModelChange)="noTilingChanged()">
  Geen (1 stuk)
</mat-checkbox>

<div class="d-flex">
  <checkbox
    class="right-space"
    [(checked)]="checkHorizontalTiling"
    [text]="'Horizontaal'"
    (answer)="horizontalTilingCheckChanged($event)"
  ></checkbox>
  <mat-form-field appearance="outline" *ngIf="checkHorizontalTiling">
    <input
      type="number"
      class="form"
      matInput
      placeholder="Aantal horizontaal"
      [(ngModel)]="inputTilingAware.numTilingHorizontal"
      (ngModelChange)="numHorizontalTiling($event)"
    />
  </mat-form-field>
</div>

<div class="d-flex bottom-space">
  <checkbox
    class="vertical-tiling-right-space"
    [(checked)]="checkVerticalTiling"
    [text]="'Verticaal'"
    (answer)="verticalTilingCheckChanged($event)"
  ></checkbox>
  <mat-form-field appearance="outline" *ngIf="checkVerticalTiling">
    <input
      type="number"
      class="form"
      matInput
      placeholder="Aantal verticaal"
      [(ngModel)]="inputTilingAware.numTilingVertical"
      (ngModelChange)="numVerticalTiling($event)"
    />
  </mat-form-field>
</div>
